<template>
  <div v-if="$store.getters.isRestaurant" class="d-flex flex-row grey lighten-4 rounded-pill py-1 px-1 me-2">
    <v-btn id="btn-accesos-meseros" icon small class="my-auto" color="primary" title="Meseros y cocina: cómo entrar" aria-label="Meseros y cocina" @click="abierto = true">
      <v-icon>mdi-silverware-fork-knife</v-icon>
    </v-btn>

    <v-dialog v-model="abierto" max-width="560" scrollable>
      <v-card id="dialogo-accesos-meseros">
        <v-card-title class="text-h6">Meseros y cocina</v-card-title>
        <v-card-text>
          <p class="body-2 mb-4">
            Cada uno entra desde su propio equipo, con su usuario. Abre la dirección en el navegador del celular, la tablet o la pantalla
            de cocina, y guárdala como acceso directo («Agregar a pantalla de inicio») para no escribirla otra vez.
          </p>
          <div v-for="a in accesos" :key="a.clave" class="acceso mb-3" :id="'acceso-' + a.clave">
            <v-icon large color="primary" class="mr-3">{{ a.icono }}</v-icon>
            <div class="acceso__texto">
              <strong>{{ a.titulo }}</strong>
              <div class="caption grey--text text--darken-1">{{ a.descripcion }}</div>
              <div class="acceso__direccion">{{ a.url }}</div>
            </div>
            <div class="acceso__acciones">
              <v-btn small depressed color="primary" :href="a.url" target="_blank" rel="noopener">Abrir</v-btn>
              <v-btn small text color="primary" @click="copiar(a)">{{ copiado === a.clave ? "Copiada" : "Copiar" }}</v-btn>
            </div>
          </div>
          <div class="d-flex align-center flex-wrap" v-if="qr">
            <img :src="qr" alt="Código QR de la app de meseros" width="132" height="132" class="mr-4" id="qr-meseros" />
            <p class="caption grey--text text--darken-1 mb-0" style="flex: 1; min-width: 180px">
              Desde el celular del mesero, escanea el código para abrir la app de pedidos.
            </p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="abierto = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import QRCode from "qrcode";

/**
 * Cómo entrar a la app de meseros (/ventas) y a la pantalla de cocina (/screen): solo en negocios de tipo restaurante.
 * En la app de escritorio el equivalente es `escritorio/MeserosYCocina.vue`, que además sirve esas pantallas por el wifi del local.
 */
export default {
  name: "AccesosMeseros",
  data: () => ({ abierto: false, qr: null, copiado: null }),
  computed: {
    base() {
      return window.location.origin;
    },
    accesos() {
      return [
        { clave: "meseros", icono: "mdi-cellphone-check", titulo: "App de meseros", descripcion: "Toman los pedidos en la mesa y los envían a la caja y a cocina.", url: this.base + "/ventas" },
        { clave: "cocina", icono: "mdi-chef-hat", titulo: "Pantalla de cocina", descripcion: "Muestra los pedidos por preparar; en una tablet o pantalla fija de la cocina.", url: this.base + "/screen" },
      ];
    },
  },
  watch: {
    async abierto(v) {
      if (v && !this.qr) this.qr = await QRCode.toDataURL(this.accesos[0].url, { width: 132, margin: 1 });
    },
  },
  methods: {
    async copiar(a) {
      try {
        await navigator.clipboard.writeText(a.url);
        this.copiado = a.clave;
        setTimeout(() => (this.copiado = null), 1800);
      } catch (e) {
        /* Sin permiso para copiar: la dirección está a la vista para escribirla. */
      }
    },
  },
};
</script>

<style scoped>
.acceso { display: flex; align-items: center; padding: 12px; border: 1px solid #e5e7eb; border-radius: 12px; }
.acceso__texto { flex: 1; min-width: 0; }
.acceso__direccion { font-size: 12px; font-family: monospace; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.acceso__acciones { display: flex; flex-direction: column; align-items: stretch; gap: 2px; margin-left: 8px; }
</style>
